import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import { Button, FormHelperText, IconButton } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const useStyles = makeStyles((theme) => ({
  root2: { height: "32px" },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    width: "150px",
    overflowX: "hidden",
  },
  chip: {
    margin: 2,
    fontSize: "12px",
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

export default function EditMultipleSelect(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [selectedValues, setSelectedValues] = React.useState([]);

  const handleChange = (event) => {
    setSelectedValues(event.target.value.sort());
  };

  return (
    <div>
      {props.quickSelectionValues?.map((quickSelection, index) => {
        return (
          <Button
            key={index}
            onClick={() => {
              props.handleOnClick(quickSelection);
            }}
          >
            {JSON.stringify(quickSelection)}
          </Button>
        );
      })}
      <div style={{ display: "flex", flexFlow: "wrap" }}>
        <IconButton color={"primary"} onClick={() => props.handleOnClick(selectedValues)}>
          <AddCircleIcon />
        </IconButton>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-mutiple-chip-label">{props.type}</InputLabel>
          <Select
            labelId="demo-mutiple-chip-label"
            id="demo-mutiple-chip"
            multiple
            value={selectedValues}
            onChange={handleChange}
            classes={{ root: classes.root2 }}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value) => (
                  <Chip key={value} label={value} className={classes.chip} size={"small"} />
                ))}
              </div>
            )}
            MenuProps={MenuProps}
          >
            {props.selectionValues.map((name) => (
              <MenuItem key={name} value={name} style={getStyles(name, selectedValues, theme)}>
                {name}
              </MenuItem>
            ))}
          </Select>
          {props.errorMessage && (
            <FormHelperText error={props.errorMessage} classes={{ error: classes.error }}>
              {props.errorMessage}
            </FormHelperText>
          )}
        </FormControl>
      </div>
    </div>
  );
}
